module.exports = __webpack_public_path__ + "img/vertical_layout_6.8c4bea45.png";